module.exports = __webpack_public_path__ + "static/media/logo-aspprev-05.1baed1e2.png";